export const ADD_TICKET = "ADD_TICKET";
export const REMOVE_TICKET = "REMOVE_TICKET";
export const EMPTY_CART = "EMPTY_CART";
